import { createFormula } from "./functions/createFormula";
import { duplicateEntries } from "./functions/duplicateEntries";
import { findFunction } from "./functions/findFunction";
import { skipCondition } from "./functions/skipCondition";
import { execute_groupBy } from "./functions/groupBy";
import { switchColumns } from "./functions/switchColumn";
import { insertCustomData } from "./functions/insertCustomData";
import { dateAndCharacterCode } from "./functions/dateAndCharacterCodes";
import { aggregateColumnData } from "./functions/aggregateColumnData";
import { mergeColumns } from "./functions/mergeColumns";
import { sumColumnPairs } from "./functions/sumColumnPairs";
import { fintechFunction } from "./functions/fintechFunction";
import { invoiceGenerator } from "./functions/invoiceGenerator";
import { parse, format, addDays, addMonths, lastDayOfMonth } from "date-fns";
import { Modal } from "antd";
import toast from "react-hot-toast";
import Decimal from "decimal.js";
export const dateFormatMap = {
  ddmmyyyy: (date) =>
    `${String(date.getDate()).padStart(2, "0")}${String(
      date.getMonth() + 1,
    ).padStart(2, "0")}${date.getFullYear()}`,
  yyyyddmm: (date) =>
    `${date.getFullYear()}${String(date.getDate()).padStart(2, "0")}${String(
      date.getMonth() + 1,
    ).padStart(2, "0")}`,
  yyyymmdd: (date) =>
    `${date.getFullYear()}${String(date.getMonth() + 1).padStart(
      2,
      "0",
    )}${String(date.getDate()).padStart(2, "0")}`,
  "yyyy/dd/mm": (date) =>
    `${date.getFullYear()}/${String(date.getDate()).padStart(2, "0")}/${String(
      date.getMonth() + 1,
    ).padStart(2, "0")}`,
  "yyyy/mm/dd": (date) =>
    `${date.getFullYear()}/${String(date.getMonth() + 1).padStart(
      2,
      "0",
    )}/${String(date.getDate()).padStart(2, "0")}`,
  "dd/mm/yyyy": (date) =>
    `${String(date.getDate()).padStart(2, "0")}/${String(
      date.getMonth() + 1,
    ).padStart(2, "0")}/${date.getFullYear()}`,
  "dd-mm-yyyy": (date) =>
    `${String(date.getDate()).padStart(2, "0")}-${String(
      date.getMonth() + 1,
    ).padStart(2, "0")}-${date.getFullYear()}`,
  "mm-dd-yyyy": (date) =>
    `${String(date.getMonth() + 1).padStart(2, "0")}-${String(
      date.getDate(),
    ).padStart(2, "0")}-${date.getFullYear()}`,
};

export const dateformats = [
  // Day-Month-Year (DMY) variations
  "dd/MM/yyyy", // Example: 15/01/2024
  "d/M/yyyy", // Example: 5/1/2024
  "dd-MM-yyyy", // Example: 15-01-2024
  "d-M-yyyy", // Example: 5-1-2024
  "dd.MM.yyyy", // Example: 15.01.2024
  "d.M.yyyy", // Example: 5.1.2024

  // Month-Day-Year (MDY) variations
  "MM/dd/yyyy", // Example: 01/15/2024
  "M/d/yyyy", // Example: 1/5/2024
  "MM-dd-yyyy", // Example: 01-15-2024
  "M-d-yyyy", // Example: 1-5-2024
  "MM.dd.yyyy", // Example: 01.15.2024
  "M.d.yyyy", // Example: 1.5.2024

  // Year-Month-Day (YMD) variations
  "yyyy-MM-dd", // Example: 2024-01-15
  "yyyy/MM/dd", // Example: 2024/01/15
  "yyyy.MM.dd", // Example: 2024.01.15
  "yyyyMMdd", // Example: 20240115 (compact format)

  // Day-Month-Year with short year
  "dd/MM/yy", // Example: 15/01/24
  "d/M/yy", // Example: 5/1/24
  "dd-MM-yy", // Example: 15-01-24
  "d-M-yy", // Example: 5-1-24
  "dd.MM.yy", // Example: 15.01.24
  "d.M.yy", // Example: 5.1.24

  // Month-Day-Year with short year
  "MM/dd/yy", // Example: 01/15/24
  "M/d/yy", // Example: 1/5/24
  "MM-dd-yy", // Example: 01-15-24
  "M-d-yy", // Example: 1-5-24
  "MM.dd.yy", // Example: 01.15.24
  "M.d.yy", // Example: 1.5.24

  // Other variations (text-based or ISO-like formats)
  "yyyy MMM dd", // Example: 2024 Jan 15
  "dd MMM yyyy", // Example: 15 Jan 2024
  "MMM dd, yyyy", // Example: Jan 15, 2024
  "dd-MMM-yyyy", // Example: 15-Jan-2024
  "d MMM yyyy", // Example: 5 Jan 2024
  "MMMM d, yyyy", // Example: January 5, 2024
];

export const headings = {
  fileSettings: "Input File Settings",
  outputFileSettings: "Output File Settings",
  grpby: "Group By Feature",
  hasChrCodes: "Add Characters",
  cmb: "Add Combination",
  swt: "Switch Column data to Column",
  find: "Find Data in Column",
  skipCondition: "Add Skip Conditions",
  addCharacterCodes: "Add Character Codes",
  inputColumnForm: "Input Columns",
  outputColumnForm: "Output Columns",
  ReadFile: "Read File",
  Configure: "Configure",
  duplicate: "Duplicate Entries",
  formula: "Create Formula",
  CreateCustomColumn: "Create Custom Column",
  DateAndCharacterCodeComb: "Date And Character Code",
  mergeColumns: "Merge Columns",
  Aggregate: "Aggregate",
  sumColumnPairs: "Create Column Pairs",
  "fin-tech": "Fin-tech File Rule",
  InvoiceGenerator: "Invoice Number Configuration",
};

export const rulesProperties = {
  1: {
    ruleName: "GroupBy Column",
    actionName: "grpby",
    description:
      "Group data based on provided columns creaking an unique combined key",
    function: (
      worksheet,
      outputSheet,
      rules,
      rule,
      fileSettings,
      inputColumns,
      outputColumns,
    ) =>
      execute_groupBy(
        rule,
        worksheet,
        outputSheet,
        inputColumns,
        outputColumns,
      ),
  },
  2: {
    ruleName: "Find",
    actionName: "find",
    function: (
      worksheet,
      outputSheet,
      rules,
      rule,
      fileSettings,
      inputColumns,
      outputColumns,
    ) =>
      findFunction(
        worksheet,
        outputSheet,
        rules,
        rule,
        fileSettings,
        inputColumns,
        outputColumns,
      ),

    summaryFunction: (rule, result, summary) => {
      const operation = {
        ruleId: 2,
        ruleName: "Find",
        inputColumn: rule.inColChr,
        searchCriteria: rule.findValue || rule.condition,
        matchesFound: result?.matchCount || 0,
        totalRowsSearched: result?.totalRows || 0,
        status: result ? "success" : "failed",
      };
      summary.rulesExecution.ruleResults.push(operation);
    },
  },

  3: {
    // this grouby is deprecated use Id 1
    ruleName: "GroupBy Column", // Human-readable name
    actionName: "grpby",
    description: "Group by data", // Description of the rule
    function: (
      worksheet,
      outputSheet,
      rules,
      rule,
      fileSettings,
      inputColumns,
      outputColumns,
    ) =>
      switchColumns(
        worksheet,
        outputSheet,
        rules,
        rule,
        fileSettings,
        inputColumns,
        outputColumns,
      ),

    outputType: 1, // 1 : output is saved in single column

    // outputHandler: (output, worksheet) => handleOutputSingleColumn(output, worksheet), // Function to store the result findFunction
  },
  4: {
    actionName: "swt",
    description:
      "Moves data of input worksheet's column to output worksheet column.", // Description of the rule
    function: (
      worksheet,
      outputSheet,
      rules,
      rule,
      fileSettings,
      inputColumns,
      outputColumns,
    ) =>
      switchColumns(
        worksheet,
        outputSheet,
        rules,
        rule,
        fileSettings,
        inputColumns,
        outputColumns,
      ),
    ruleName: "Switch Column Data", // Human-readable name
    outputType: 1, // 1 : output is saved in single column
  },

  5: {
    ruleName: "Skip Condition",
    actionName: "skipCondition",
    description: "Skip Row/Cell based on condition defined for a cell data",

    function: (
      worksheet,
      outputSheet,
      rules,
      rule,
      fileSettings,
      inputColumns,
      outputColumns,
    ) =>
      skipCondition(
        worksheet,
        outputSheet,
        rules,
        rule,
        fileSettings,
        inputColumns,
        outputColumns,
      ),

    outputType: 1,
  },

  6: {
    ruleName: "Duplicate Entries", // Human-readable name
    actionName: "duplicate",
    description:
      "Duplicates entries found in input column using find function in output column (for now)", // Description of the rule
    outputType: 1, // 1 : output is saved in single column

    function: (
      worksheet,
      outputSheet,
      rules,
      rule,
      fileSettings,
      inputColumns,
      outputColumns,
    ) =>
      duplicateEntries(
        worksheet,
        outputSheet,
        rules,
        rule,
        fileSettings,
        inputColumns,
        outputColumns,
      ),
  },

  7: {
    ruleName: "Create Formula",
    actionName: "formula",
    description: "Create mathematical formula",
    outputType: 1,
    function: (
      worksheet,
      outputSheet,
      rules,
      rule,
      fileSettings,
      inputColumns,
      outputColumns,
    ) =>
      createFormula(
        worksheet,
        outputSheet,
        rules,
        rule,
        fileSettings,
        inputColumns,
        outputColumns,
      ),
  },

  8: {
    ruleName: "Custom Data",
    actionName: "CreateCustomColumn",
    description:
      "Add custom data into columns such as (contactName, description etc)",
    outputType: 1, // 1 : output is saved in single column
    function: (
      worksheet,
      outputSheet,
      rules,
      rule,
      fileSettings,
      inputColumns,
      outputColumns,
    ) =>
      insertCustomData(
        worksheet,
        outputSheet,
        rules,
        rule,
        fileSettings,
        inputColumns,
        outputColumns,
      ),
  },
  9: {
    ruleName: "Date and Character Code",
    actionName: "DateAndCharacterCodeComb",
    description:
      "This function is used to modify date format and concatenate character codes with it",
    function: (
      worksheet,
      outputSheet,
      rules,
      rule,
      fileSettings,
      inputColumns,
      outputColumns,
    ) =>
      dateAndCharacterCode(
        worksheet,
        outputSheet,
        rules,
        rule,
        fileSettings,
        inputColumns,
        outputColumns,
      ),
  },
  10: {
    ruleName: "Aggregate",
    actionName: "Aggregate",
    description:
      "This function is used to aggregate data in a column for sum, average etc",
    function: (
      worksheet,
      outputSheet,
      rules,
      rule,
      fileSettings,
      inputColumns,
      outputColumns,
    ) =>
      aggregateColumnData(
        worksheet,
        outputSheet,
        rules,
        rule,
        fileSettings,
        inputColumns,
        outputColumns,
      ),
  },
  11: {
    ruleName: "Merge Columns",
    actionName: "mergeColumns",
    description:
      "This function is used to merger two or more then two columns and save it in one column, this can work both on input file and output file. ",
    function: (
      worksheet,
      outputSheet,
      rules,
      rule,
      fileSettings,
      inputColumns,
      outputColumns,
    ) =>
      mergeColumns(
        worksheet,
        outputSheet,
        rules,
        rule,
        fileSettings,
        inputColumns,
        outputColumns,
      ),
  },
  12: {
    ruleName: "Create Column Pairs",
    actionName: "sumColumnPairs",
    description:
      "This function is used to create column pairs and save them in output column",
    function: (
      worksheet,
      outputSheet,
      rules,
      rule,
      fileSettings,
      inputColumns,
      outputColumns,
    ) =>
      sumColumnPairs(
        worksheet,
        outputSheet,
        rules,
        rule,
        fileSettings,
        inputColumns,
        outputColumns,
      ),
  },
  13: {
    ruleName: "Fin-tech File Rule",

    description:
      "This function is adding debit/credit separately in output columns and generates multiple files base on currency.",
    function: (
      worksheet,
      outputSheet,
      rules,
      rule,
      fileSettings,
      inputColumns,
      outputColumns,
    ) =>
      fintechFunction(
        worksheet,
        outputSheet,
        rules,
        rule,
        fileSettings,
        inputColumns,
        outputColumns,
      ),
  },
  14: {
    ruleName: "Invoice Number Configuration",
    actionName: "InvoiceGenerator",
    description:
      "Customize how invoice numbers are generated by adding and arranging components such as prefixes, date formats, sequential numbers, and suffixes to create a unique invoice numbering system that fits your business needs.",
    function: (
      worksheet,
      outputSheet,
      rules,
      rule,
      fileSettings,
      inputColumns,
      outputColumns,
    ) =>
      invoiceGenerator(
        worksheet,
        outputSheet,
        rules,
        rule,
        fileSettings,
        inputColumns,
        outputColumns,
      ),
  },
};

export const addColumnHeader = (worksheet, data, columnName) => {
  // console.log("addColumnHeader", columnName);
  let find = data.find((obj) => obj.outColChr === columnName);
  worksheet.getCell(`${find.outColChr}${1}`).value =
    find?.outputColumnHeader ?? "new header";
};

export function getNumericValue(cellValue) {
  if (!cellValue) return 0;
  const numericPart = cellValue.toString().match(/-?\d+(\.\d+)?/);
  return numericPart ? parseFloat(numericPart[0]) : 0;
}

export function extractObjectsByRule(array) {
  const objectsWithEntireRowSkipCondition = array.filter(
    (obj) => obj.appliedRule === 5,
  );
  const modifiedOriginal = array.filter(
    (obj) => !(obj.appliedRule === 5 && obj.entireRow === true),
  );
  return { objectsWithEntireRowSkipCondition, modifiedOriginal };
}
export const columnDataTypes = {
  1: "Text",
  2: "Number",
  3: "Date",
};

export const optionsForInputColumn = {
  inColDesc: "Insert Description",
  inColCharCode: "Insert Char Code",
  inColDueDate: "Insert Due Date",
  inColContactName: "Insert Contact Name",
  inColExchangeRate: "Insert Exchange Rate",
  inColAccountNo: "Insert Account No",
  inColDcCode: "Insert DC Code",
  insertDate: "Insert Date",
  insertCellData: "Insert Cell Data",
  exchangeRateMultiply: "Multiply by Exchange Rate",
  oid: "Unique Record Identifier",
  insertEndDate: "Insert End Date",
  insertStartDate: "Insert Start Date",
  insertDateRange: "Insert Date Range",
  insertStartDatePlusDueDate: "Insert Start Date + Due Date",
  insertEndDatePlusDueDate: "Insert End Date + Due Date",
};

export const mapToExcelIndexes = (column) => {
  let index = 0;
  for (let i = 0; i < column.length; i++) {
    index = index * 26 + (column.charCodeAt(i) - 64);
  }
  return index;
};
export const toolTipDescriptions = {
  inputColumnName: "Enter the column name associated with the input sheet.",
  inputDateType: "Select the type of data contained in this column.",
  inputColumnContactName: "Enter the contact name related to this column.",

  inputColumnDesc: "Provide a description for this column.",
  inColDueDate: "Select the number of days until the payment is due.",

  inputColumnDateFormat: "Select the current date format of this column.",
  convertToDateFormat: "Choose the target date format for conversion.",
  inputColumnCharCode: "Enter the character code for this column.",
  accountNumber: "Enter the account number associated with this column.",
  inputColumnDCCode: "Enter the DC code related to this column.",

  inColExchangeRate: "Enter the applicable exchange rate for this column.",
};
export const addDueDateToDate = (dateString, formatString, daysToAdd) => {
  // Parse the date using the provided format
  const parsedDate = parse(dateString, formatString, new Date());

  let newDate;

  if (!Number.isInteger(Number(daysToAdd))) {
    const key = daysToAdd.toLowerCase();

    if (key === "endofthemonth") {
      newDate = lastDayOfMonth(parsedDate);
    } else if (key === "samedaydue") {
      newDate = parsedDate;
    } else if (key === "duein1month") {
      newDate = addMonths(parsedDate, 1);
    } else {
      throw new Error(`Invalid daysToAdd value: ${daysToAdd}`);
    }
  } else {
    // Add the specified number of days
    newDate = addDays(parsedDate, parseInt(daysToAdd));
  }
  // console.log( "DateString ", dateString,"newDate", "parse Date", parsedDate ,"Due Date",newDate, "formatString", formatString);
  // Format the new date back to the original format
  return format(newDate, formatString);
};

function getDescriptionValueFromGraph(customGrouping, groupKey) {
  for (const key in customGrouping) {
    // console.log("key", key, "groupKey", groupKey, );
    if (key === groupKey) {
      // console.log("customGrouping[key].additionalField", customGrouping[key].additionalField);
      return customGrouping[key].additionalField; // Return "L" value
    }
  }
  return null; // Return null if not found
}
// merge rows based on the combination of date and category
// For example combine Visa, Master to  Visa/Master , used for atlas and lazada
export const combineGroupedPayments = (groupedData, customGrouping, rule) => {
  const result = {};
  // Set mappings once before the loop
  const mappings = {
    dateColumn: rule.dateColumn,
    aggregateColumn: rule.aggregateColumn,
    conditionalColumn: rule.conditionalColumn,
    descriptionColumn: rule.descriptionColumn, //used for lazada for extra description
  };

  for (const key in groupedData) {
    // Extract values dynamically
    let dateObject = groupedData[key][mappings.dateColumn];
    let dateValue = `${dateObject?.startDate} - ${dateObject?.endDate}`; // Assuming dateObject has startDate and endDate properties
    let aggregateValue = groupedData[key][mappings.aggregateColumn];
    let conditionalValue = groupedData[key][mappings.conditionalColumn];

    // Find the corresponding group for Conditional Column
    let groupKey;
    if (rule.useExtraField) {
      groupKey =
        Object.keys(customGrouping).find((group) =>
          customGrouping[group].values.includes(conditionalValue),
        ) || conditionalValue;
    } else {
      groupKey =
        Object.keys(customGrouping).find((group) =>
          customGrouping[group].includes(conditionalValue),
        ) || conditionalValue;
    }

    const newKey = `${
      rule?.dateColumnType === "week" ? dateValue : dateObject
    }*${groupKey}`;

    if (!result[newKey]) {
      result[newKey] = {
        [mappings.dateColumn]: dateObject, // Use the date object directly which has startDate and endDate
        [mappings.conditionalColumn]: groupKey,
        [mappings.aggregateColumn]: 0,
      };
    }
    if (rule.useExtraField) {
      result[newKey][rule.descriptionColumn] = getDescriptionValueFromGraph(
        customGrouping,
        groupKey,
      );
    }

    result[newKey][mappings.aggregateColumn] = new Decimal(
      result[newKey][mappings.aggregateColumn] || 0,
    )
      .plus(new Decimal(aggregateValue || 0))
      .toNumber();
  }

  return result;
};
export function groupByWeekWithoutCrossingMonths(data, rule, inputColumns) {
  const groupedData = {};
  // Find the dat column and extract the todateformat, the current format of date
  const dateColumn = rule.dateColumn;
  const column = inputColumns.find((col) => col.inColChr === dateColumn);
  const outputFormat = column.toDateFormat;

  Object.entries(data).forEach(([key, value]) => {
    const [dateStr, category] = key.split("*"); // Extract date and category
    // const date = new Date(dateStr); // Convert to Date object
    const date = parse(dateStr, outputFormat, new Date());
    if (isNaN(date)) return; // Skip invalid dates

    const month = date.getMonth();
    const year = date.getFullYear();

    // Find the start (Monday) and end (Sunday) of the week
    let weekStart = new Date(date);
    weekStart.setDate(date.getDate() - ((date.getDay() + 6) % 7)); // Move to Monday

    let weekEnd = new Date(weekStart);
    weekEnd.setDate(weekStart.getDate() + 6); // Move to Sunday

    // Get the last day of the current month
    const lastDayOfMonth = new Date(year, month + 1, 0);

    // Ensure week does not cross into the next month
    if (weekEnd > lastDayOfMonth) {
      weekEnd = lastDayOfMonth;
    }
    // Ensure week does not start before the first day of the current month
    const firstDayOfMonth = new Date(year, month, 1);
    if (weekStart < firstDayOfMonth) {
      weekStart = firstDayOfMonth;
    }

    // Format the week range correctly
    const startDateStr = weekStart.toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "2-digit",
      year: "2-digit",
    });
    const endDateStr = weekEnd.toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "2-digit",
      year: "2-digit",
    });

    // Create new key with the corrected week range
    const newKey = `${startDateStr} - ${endDateStr}*${category}`;
    // Aggregate `H` values
    if (!groupedData[newKey]) {
      groupedData[newKey] = {
        // [rule.dateColumn]: `${startDateStr} - ${endDateStr}`,
        [rule.dateColumn]: { startDate: startDateStr, endDate: endDateStr },
        [rule.conditionalColumn]: category,
        [rule.aggregateColumn]: 0,
      };
    }

    // groupedData[newKey].H += value.H; // Sum the H values

    // groupedData[newKey][rule.aggregateColumn] += value[rule.aggregateColumn]; // Sum the aggregate values (this was original line)

    groupedData[newKey][rule.aggregateColumn] = new Decimal(
      groupedData[newKey][rule.aggregateColumn],
    )
      .plus(new Decimal(value[rule.aggregateColumn]))
      .toNumber();
  });

  return groupedData;
}

export const allowedRules = [
  2, // 2:FindRule
  1, //grouping rule
];
// Function to format date from MM/DD/YYYY to DDMMYY
export function formatDateToDDMMYY(dateString) {
  let dateObj = new Date(dateString);
  console.log("dateObj", dateObj, "dateString", dateString);
  let day = String(dateObj.getDate()).padStart(2, "0");
  let month = String(dateObj.getMonth() + 1).padStart(2, "0"); // Months are zero-based
  let year = String(dateObj.getFullYear()).slice(-2); // Get last two digits of year
  return `${day}${month}${year}`;
}

export function showAddedRulesToast(ruleId, type = "added") {
  toast.success(
    `'${rulesProperties[ruleId].ruleName}' rule has been ${type} successfully!`,
  );
  toast.remove("ruleAddedToast"); // Remove any existing toast with the same ID
}

export const showConfirmDelete = (
  itemName,
  onConfirm,
  close,
  _additionalWarning = "",
) => {
  Modal.confirm({
    title: "Confirm Deletion",
    content: (
      <>
        Are you sure you want to delete "{itemName}"? This action cannot be
        undone.
        {_additionalWarning && (
          <>
            <br />
            <span style={{ color: "red" }}>{_additionalWarning}</span>
          </>
        )}
      </>
    ),
    okText: "Delete",
    okType: "danger",
    cancelText: "Cancel",
    onOk() {
      onConfirm();
    },
    onCancel() {
      close();
      // Handle cancel action if needed
    },
  });
};
